import { Component, Input, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthService, SwitchLanguageService } from '@pt/api-client';
import { PtCoreActions } from '@pt/pt-core';
import { IoniconsOutline } from '@pt/pt-models';
import { Subject, timer } from 'rxjs';

@Component({
  selector: 'pt-unexpected-error-manager',
  template: `
    <div id="errorPage">
      <pt-auth-img-area class="position-absolute" style="top: 0; left: 0" [showPTLogo]="false"></pt-auth-img-area>
      <div class="w-100 vh-100 d-flex flex-column justify-content-center align-items-center">
        <div class="d-flex flex-row justify-content-center">
          <div class="d-flex flex-column justify-content-start">
            <div class="w-100 text-center text-black-50" style="font-size: 5rem">
              Ooops!
            </div>
            <div class="h4 text-muted text-center mt-4 message-container"
                 [innerHtml]="'MESSAGE.UNEXPECTED_ERROR_OCCURRED' | translate"
            ></div>
          </div>
        </div>
        <div class="mt-4 w-200-px d-flex flex-column align-items-center justify-content-center">
          <button class="btn btn-link btn-sm d-flex" style="font-size: 1.1rem" (click)="toHomePage()">
            <pt-icon [key]='IconArrowLeft' [size]="18" class="hstack" style="margin-bottom: 3px"></pt-icon>
            {{"BUTTON.GO_TO_HOME" | translate}}
          </button>
          <div>{{"LABELS.OR" | translate | lowercase}}</div>
          <button class="btn btn-link btn-sm d-flex" style="font-size: 1.1rem" (click)="reloadPage()">
            <pt-icon [key]='IconReload' [size]="18" class="hstack" style="margin-bottom: 3px"></pt-icon>
            {{"BUTTON.REFRESH_PAGE" | translate}}
          </button>
        </div>
      </div>
    </div>
  `
})
export class UnexpectedErrorComponent implements OnDestroy {

  @Input() homePath: string;

  public IconArrowLeft = IoniconsOutline.arrowLeft;
  public IconReload = IoniconsOutline.reload;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public switchLanguageService: SwitchLanguageService,
    private authService: AuthService,
    private store: Store,
  ) {
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  toHomePage() {
    this.store.dispatch(PtCoreActions.navigateTo({route: [this.homePath]}));
    timer(250).subscribe(() => {
      this.reloadPage();
    });
  }

  reloadPage() {
    window.location.reload();
  }

}
